export class ManfrediteOffersApplicationAttempt {
}
export class ManfrediteOffers {
}
//# sourceMappingURL=manfredite-offers.js.map